import PropTypes from 'prop-types';
import React from 'react';
import Lightbox from './ContentModules/Lightbox';
import EmbeddedContent from './ContentModules/EmbeddedContent';

export const ReuseContentModule = ({ contentModule }) => {
  switch (contentModule.mediaType) {
    case 'ContentfulLightbox':
      return <Lightbox lightboxData={contentModule} />;
    default:
      return <EmbeddedContent embeddedContent={contentModule} />;
  }
};

ReuseContentModule.propTypes = {
  contentModule: PropTypes.any,
};

export default ReuseContentModule;
